var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    fill: "#A51931"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 3,
    fill: "#F4F5F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 24,
    height: 6,
    fill: "#2D2A4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 24,
    height: 3,
    fill: "#F4F5F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 24,
    height: 3,
    fill: "#A51931"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/th.8f55ad57b348c0d7c44a78e82589a7f5.svg";
export { ForwardRef as ReactComponent };